import { Button, InfoIcon } from '@ticketmaster/aurora';
import IconSwipeCard from '@ticketmaster/tm1pos-web-shared/components/icons/IconSwipeCard';
import SmallSpinnerComponent from '@ticketmaster/tm1pos-web-shared/components/SmallSpinnerComponent';
import classNames from 'classnames';
import { type MouseEvent, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { clearCartLocation } from '../../../../../../middleware/mixpanel-constants';
import { clearCart, promptOrderDelete } from '../../../../../App/actions';
import messages from '../../../../messages';
import { selectEMVSetupError } from '../../../../selectors';
import { selectCardPaymentEnabled } from '../../checkout-selectors';
import { selectFormToggles } from '../../selectors';
import { isSwipeable } from './submit-button-utils';

export type SubmitButtonProps = {
  checkoutInProgress: boolean;
  invalid: boolean;
  isPaymentDeviceConnected: boolean;
  isOrderUnpaid: boolean;
};

export const SubmitButton = (props: SubmitButtonProps) => {
  const [cancelInProgress, setCancelInProgress] = useState(false);

  const emvSetupError = useSelector(selectEMVSetupError);
  const cardPaymentEnabled = useSelector(selectCardPaymentEnabled);

  const formToggles = useSelector(selectFormToggles);
  const { paymentMethod, manualCardEntry } = formToggles;

  const dispatch = useDispatch();

  function getDisabled() {
    const { invalid, checkoutInProgress } = props;
    return invalid || checkoutInProgress;
  }

  function checkoutBtn() {
    const disabled = getDisabled() || cancelInProgress;
    return (
      <>
        <Button
          type="button"
          // @ts-expect-error - onClick does not exist on button type for some reason
          onClick={cancelCurrentCart}
          variant="transparent"
          className="sdr-checkout__btn--cancel"
        >
          <FormattedMessage {...messages.cancel} />
        </Button>
        <Button
          // @ts-expect-error - id does not exist on button type for some reason
          id="checkout-btn"
          type="submit"
          className="sdr-checkout__btn--checkout"
          disabled={disabled}
        >
          {props.checkoutInProgress ? <SmallSpinnerComponent /> : <FormattedMessage {...messages.checkoutNow} />}
        </Button>
      </>
    );
  }

  function swipeBtn() {
    const disabled = getDisabled();
    const swipeClassNames = classNames({
      'swipe-card-btn': true,
      'swipe-card-btn--disabled': disabled,
    });
    return (
      <div id="swipe-btn" className={swipeClassNames}>
        <div className="checkout-swipe__btn">
          {disabled ? <InfoIcon type="filled" size="regular" /> : <IconSwipeCard />}
        </div>
        <div className="checkout-swipe__text">
          {disabled ? <FormattedMessage {...messages.fillInfo} /> : <FormattedMessage {...messages.swipeCardNow} />}
        </div>
        <div className="checkout-swipe__cancel">
          {' '}
          <Button
            type="button"
            // @ts-expect-error - id does not exist on button type for some reason
            onClick={cancelCurrentCart}
            variant="transparent"
          >
            <FormattedMessage {...messages.cancel} />
          </Button>
        </div>
      </div>
    );
  }

  const cancelCurrentCart = (clickEvent: MouseEvent<HTMLButtonElement>) => {
    preventPerformingCheckout(clickEvent);

    const { isOrderUnpaid } = props;
    if (isOrderUnpaid) {
      dispatch(promptOrderDelete());
    } else {
      setCancelInProgress(true);
      const clearPlace = clearCartLocation.CANCEL_BUTTON;
      dispatch(clearCart(clearPlace));
    }
  };

  const preventPerformingCheckout = (clickEvent: MouseEvent<HTMLButtonElement>) => {
    clickEvent.preventDefault();
  };

  const showSwipe = isSwipeable(
    paymentMethod,
    manualCardEntry,
    props.isPaymentDeviceConnected,
    emvSetupError,
    cardPaymentEnabled,
  );
  const btnClassNames = classNames({
    'sdr-checkout__btn-wrap': true,
    'sdr-checkout__btn-wrap--card': showSwipe,
  });
  return <div className={btnClassNames}>{showSwipe ? swipeBtn() : checkoutBtn()}</div>;
};
